export interface UserGuideSection {
  id: string;
  number?: string;
  title: string;
  content: string;
  subsections?: UserGuideSection[];
}

export const USER_GUIDE_META = {
  title: 'Orbius Portal User Guide',
  company: 'Orbius Communications',
  email: 'solutions@orbius.com',
  version: '3.5',
  date: 'March 2026',
  pdfFilename: 'Orbius-Portal-User-Guide-v3.5.pdf',
} as const;
